// Logica prezzi XMOVE: canoni base IVA ESCLUSA e senza anticipo.
// L'anticipo riduce il totale del noleggio: canone = (canone_base * durata - anticipo) / durata.

export const IVA_MULT = 1.22;

export const totaleNoleggio = (canone, durata) => canone * durata;

// Anticipo proposto di default: cifra tonda (migliaia) piu' vicina al 10% del totale, tra 2.000 e 15.000
export const anticipoDefault = (canone, durata) => {
  const dieciPct = Math.round((totaleNoleggio(canone, durata) * 0.1) / 1000) * 1000;
  return Math.min(15000, Math.max(2000, dieciPct));
};

// Opzioni anticipo: Zero, poi da 2.000 a 15.000 a passi di 1.000, senza mai superare il totale del noleggio
export const anticipoOptions = (canone, durata) => {
  const tot = totaleNoleggio(canone, durata);
  const max = Math.min(15000, Math.floor((tot - 1) / 1000) * 1000);
  const opts = [0];
  for (let a = 2000; a <= max; a += 1000) opts.push(a);
  return opts;
};

export const canoneConAnticipo = (canone, durata, anticipo) =>
  Math.max(0, Math.round((totaleNoleggio(canone, durata) - anticipo) / durata));

export const conIva = (v) => Math.round(v * IVA_MULT);

// Canone da mostrare in card: le offerte importate (anticipo null) lo mostrano con anticipo default al 10%
export const canoneCard = (offer) => {
  if (offer.canone == null) return null;
  if (offer.anticipo != null || !offer.durata_mesi) return offer.canone;
  return canoneConAnticipo(offer.canone, offer.durata_mesi, anticipoDefault(offer.canone, offer.durata_mesi));
};

export const anticipoCard = (offer) => {
  if (offer.anticipo != null) return offer.anticipo;
  if (offer.canone == null || !offer.durata_mesi) return null;
  return anticipoDefault(offer.canone, offer.durata_mesi);
};

// Separatore delle migliaia sempre visibile (il locale it-IT lo omette sotto 10.000)
// Variante da mostrare di default: SEMPRE il canone piu' basso;
// a parita' di prezzo preferiamo 48 mesi e 10.000 km/anno (regola vetrina XMOVE)
export const varianteDefault = (varianti) => {
  if (!varianti?.length) return null;
  const min = Math.min(...varianti.map((v) => v.canone));
  const pari = varianti.filter((v) => v.canone === min);
  return (
    pari.find((v) => v.durata_mesi === 48 && v.km_annui === 10000) ||
    pari.sort((a, b) => b.durata_mesi - a.durata_mesi || a.km_annui - b.km_annui)[0]
  );
};

export const fmtEuro = (v) => `€ ${String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
